export interface ISelectData {
  value: string
  label: string
}